export default function NoPromos() {
  return (
    <div className="card-promo bg-white rounded shadow px-2 py-3 p-md-3 text-align-center">
      <h4 className="h3 text-primary">
        No Events Scheduled
      </h4>
      <p className="text-dark-subtle mb-1">
        Please check back soon.
      </p>
    </div>
  )
}
